import { Col, Flex, Layout, Pagination, Row, Typography } from 'antd'
import { useContext, useEffect } from 'react'
import ImageItem from './components/ImageItem'
import { AppContext } from '../../hooks/AppContext'
import RenderFilter from './components/RenderFilter'
import { GenerateImgType, RenderTrainedInfoItemType } from '../../types'
import useRenderHistory from '../../hooks/useRenderHistory'
import Constant from '../../controller/Constant'
import { v4 as uuidv4 } from 'uuid'
import { saveAs } from 'file-saver'

const fontMobileStyle = {
  fontSize: 12
}

const RenderHistoryScreen = () => {
  const { setMenuSelected, isMobile, showErrorApiAlert } = useContext(AppContext)

  const {
    getRenderHistoryList,
    getRenderProcessing,
    handleFilter,
    schedule,
    setSchedule,
    //imgTypeSelected,
    //setImgTypeSelected,
    renderProcessingList,
    isSpinning,
    renderList,
    totalPages,
    onChangePage,
    currentPage,
    setRenderProcessingList
  } = useRenderHistory()

  const handleImageDownload = async (imageUrl: string) => {
    try {
      const response = await fetch(imageUrl)
      const blob = await response.blob()

      const fileName = uuidv4()
      saveAs(blob, fileName)
    } catch (error) {
      showErrorApiAlert(error)
    }
  }

  const handleListImgDownload = (item: GenerateImgType[]) => {
    for (let index = 0; index < item?.length; index++) {
      handleImageDownload(item[index]?.url + '?not-from-cache-please')
    }
  }

  useEffect(() => {
    setMenuSelected(Constant.keyScreen.renderHistory)
  }, [])

  useEffect(() => {
    getRenderHistoryList()
    if (currentPage <= 1) {
      getRenderProcessing()
    } else {
      setRenderProcessingList([])
    }
  }, [currentPage])

  useEffect(() => {
    const timerId = setInterval(() => {
      getRenderProcessing()
    }, 5000)

    return () => {
      clearInterval(timerId)
    }
  }, [])

  return (
    <Layout className='bg-white pb-10'>
      <h1 className='title'>画像生成履歴一覧</h1>
      <RenderFilter
        schedule={schedule}
        setSchedule={setSchedule}
        //imgTypeSelected={imgTypeSelected}
        //setImgTypeSelected={setImgTypeSelected}
        handleFilter={handleFilter}
      />
      <Col>
        <Row
          className='bg-[#5AAAFF] min-h-9 justify-center items-center mt-10 text-center'
          style={{
            width: '100%'
          }}
        >
          <Typography className='flex-1 text-white font-bold' style={isMobile ? fontMobileStyle : undefined}>
            Background image
          </Typography>
          <Typography className='flex-[1] text-white font-bold' style={isMobile ? fontMobileStyle : undefined}>
            Face image
          </Typography>
          <Typography className='flex-[1] text-white font-bold' style={isMobile ? fontMobileStyle : undefined}>
            Created at
          </Typography>
          <Row className='flex-[1.5] justify-center'>
            <Typography className='text-white font-bold' style={isMobile ? fontMobileStyle : undefined}>
              Result image
            </Typography>
          </Row>

          <Row className='flex-[0.5]'></Row>
        </Row>

        {renderProcessingList?.map((item: RenderTrainedInfoItemType) => (
          <ImageItem isRenderProcessing={true} key={item?.id} item={item} />
        ))}
        {renderList?.map((item: RenderTrainedInfoItemType) => (
          <ImageItem key={item?.id} item={item} handleListImgDownload={handleListImgDownload} />
        ))}
        {!isSpinning && renderList?.length <= 0 && renderProcessingList?.length <= 0 && (
          <Flex vertical justify='center' align='center' className='mt-[70px]'>
            <img src={require('../../assets/render-empty.png')} width='auto' height={80} />
            <div className='text-center mt-5 font-bold text-[16px]'>まだ画像がありません。</div>
          </Flex>
        )}
        <Flex justify='center' align='flex-end' className='mt-7'>
          {Number(totalPages) > 1 && (
            <Pagination
              current={currentPage}
              onChange={onChangePage}
              total={Number(totalPages) * 10}
              showSizeChanger={false}
            />
          )}
        </Flex>
      </Col>
    </Layout>
  )
}

export default RenderHistoryScreen
